const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLForm = require('app/graphql/Form');
const AutocompleteList = require('app/ui/list/Autocomplete');


const FormFactory = require('app/restaurant/analyse/product/FormFactory');


class Form extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitRestaurantProspectAnalyseProductAssociation',
            'analyse': null,
            'productAssociation': null,


            'autocompleteTriggerMinLength': 3,
            'nbAutocompleteResult': 10,
            'submitLabel': null,
            'onCancel': function(){},
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.onSubmit = this.onSubmit.bind(this)

        this.analyse = this.settings.analyse;
        this.productAssociation = this.settings.productAssociation;

        this.mode = 'create';

        this.reference = '';
        this.prospectProduct = null;
        this.linkedProduct = null;
        this.linkedProductId = '';
        this.linkedProductLabel = '';
        this.productUnit = '';
        this.productQuantity = '';
        this.quantity = '';
        this.price = '';

		this.orderedAt = this.productAssociation.orderedAt;
		this.supplierId = Object.is(this.productAssociation.supplier) ? this.productAssociation.supplier.id : this.productAssociation.supplier;
		this.id = null;

        if(this.productAssociation && this.productAssociation.id){
        	this.id = this.productAssociation.id;
        	this.mode = 'edit';
	        this.prospectProduct = this.productAssociation.product;
	        if(this.prospectProduct && this.prospectProduct.id){
		        this.reference = this.prospectProduct.reference;
		        this.linkedProduct = this.prospectProduct.product;
		        this.productUnit = this.prospectProduct.unit;
		        this.productQuantity = this.prospectProduct.quantity;

		        if(this.linkedProduct && this.linkedProduct.id){
			        this.linkedProductId = this.linkedProduct.id;

            		this.linkedProductSupplier = this.linkedProduct.supplier;
			        this.linkedProductLabel = this.linkedProduct.reference;
			    }
		    }
	        this.quantity = this.productAssociation.quantity;
	        this.price = this.productAssociation.price;
        }

        this.buildForm();
        super.initialize();
    }

    getAnalyse(){
        return this.analyse;
    }

    getProductAssociation(){
        return this.productAssociation;
    }

    getForm(){
        return this.$form;
    }


    buildForm(){
        var self = this;

        this.$form = $('<form/>')
        .addClass('restaurant-analyse-product-form');

        this.loadData();

        return this.$form;
    }

    fillForm(data){
        var self = this;

        this.units = data.supplierProductUnits;

        let submitLabel = this.mode=='edit' ? window.translate("edit") : window.translate("add");
        if(this.settings.submitLabel){
            submitLabel = this.settings.submitLabel;
        }
        this.$btnSubmit = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-primary')
        .append(submitLabel)
        .on('click',function(){
        	self.$form.trigger('submit');
        });

        this.$btnCancel = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-secondary')
        .append(window.translate("cancel"))
        .on('click',function(event){
            self.onClickBtnCancel(event);
        });


        this.$form
        .html('');

        this.units = data.supplierProductUnits;
        let formFactory = new FormFactory({
            'units': this.units,
            'productAssociation': this.productAssociation,
            'autocompleteTriggerMinLength': 3,
            'nbAutocompleteResult': 10,
        });
        formFactory.fillForm(this.$form);

        this.$form.append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-2')
            .append(this.$btnSubmit)
            .append('&nbsp;')
            .append(this.$btnCancel)
        );

        return this.$form;
    }

    onDOMReady(){
    }

    getFields(){
        let fields = super.getFields();
        fields.push('productAssociation { id total price quantity orderedAt supplier { name } product { id reference unit quantity product { id reference quantity unit price supplier { name } } } }');
        return fields;
    }

    getVariables(){
        let variables = {};
        variables.analyse = {
            'value': this.analyse.id,
            'type': 'Int!'
        };

        if(this.productAssociation.id){
            variables.id = {
                'value': this.productAssociation.id,
                'type': 'Int'
            };
        }
        return variables;
    }

    loadData(){
        var self = this;

        this.$form
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildProductUnitsQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillForm(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildProductUnitsQuery(){
        var self = this;

        let parameters = {
        };

        let fields = [
            'value',
            'label'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProductUnits',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;

    }


    getData(){
        let data = window.serializeForm(this.$form);
        let expectedData = {
            'analyse': {
                'id': this.analyse.id,
            },
            'quantity': data.quantity,
            'price': data.price,
            'product': {
                'reference': data.reference,
                'unit': data.productUnit,
                'quantity': data.productQuantity,
                'product':{
                    'id': data.linkedProduct
                }
            }
        };

        if(this.id){
        	expectedData['id'] = this.id;
        }else{
        	expectedData['orderedAt'] = this.orderedAt;
        	expectedData['supplier'] = {
                'id': this.supplierId
        	};
        }

        let formData = window.jsonToFormData(expectedData);
        return formData;
    }

    onClickBtnCancel(event){
        if(this.settings.onCancel){
            this.settings.onCancel();
        }
    }

    onSuccess(data){
        this.productAssociation = data.productAssociation;
        super.onSuccess(data);
    }

}


module.exports = Form;